import React, { Component } from 'react';
import Clients from './Clients';

class ClientPage extends Component {
	render () {
		return <Clients type="client" />
	}
}

export default ClientPage;



// WEBPACK FOOTER //
// ./containers/ClientPage.js